import React, { Component } from 'react'
import dateFormat from 'dateformat'
import _get from 'lodash/get'

import Lazyload from '@components/common/Lazyload/Lazyload'
import ReminderMatch from '@components/ReminderMatch'

import { getContentTypeName } from '@source/lib/globalUtil'

import { placeholderBlankSquare } from '@global/imageUrl'

import { videoContainer, icons, imageWrapper, durationContainer, SpecialRibbon } from './style'

class VideoCard extends Component {
  // componentDidMount() {
  //   console.log(this.props.data, 'ini data objek')
  // }

  render() {
    const {
      id,
      type,
      title = '',
      description = '',
      src,
      duration,
      contentType = '',
      permission = '' /* 3 is free stresming, 2 is login, 1 is premium with subscription, '' permission disabled */,
      league,
      startTime,
      endTime,
      onClick = () => {},
      containerClassName = '',
      className = '',
      transitionMode = 'scroll',
      isDetailHidden,
      isMatch = false,
      defaultPermissionCard,
      onHoverBorder = true,
      isRatio23 = false,
      reminder,
      ribbon,
      srcset,
      sizes,
    } = this.props

    // const contentTypeName = getContentTypeName(contentType),
    //   isMatch = contentTypeName === 'live' || contentTypeName === 'replay'

    const formattedLeagueType = {
      1: 'Highlights',
      3: 'Live Match',
      4: 'Replay',
    }

    const leagueName = _get(league, 'attributes.name', ''),
      leagueType = formattedLeagueType[contentType]

    let videoDuration = null
    // if (duration) {
    //   const hour = Math.floor(duration / 60),
    //     minute = duration % 60
    //   videoDuration = `${hour > 0 ? hour + 'h ' : ''}${minute > 0 ? minute + 'm' : ''}`
    // }

    const imgSizeQuery = isRatio23 ? 'w=400&h=600' : 'w=450&h=800'

    return (
      <div>
        <div onClick={() => onClick()} className={`${videoContainer} ${containerClassName}`}>
          <div className={imageWrapper}>
            {ribbon && <SpecialRibbon imgUrl={ribbon} />}
            <Lazyload
              className={`${transitionMode === 'scroll' ? 'bannerImage' : 'bannerImage3d'}`}
              src={src}
              srcset={srcset}
              sizes={sizes}
              onHoverBorder={onHoverBorder}
              fallbackImageUri={`${placeholderBlankSquare}?${imgSizeQuery}`}
            />
            {/* {videoDuration &&
              <div className={durationContainer}><span>{videoDuration}</span></div>
            } */}
          </div>
          {!isDetailHidden && (
            <>
              {title && <p className={'title'}>{title}</p>}
              {description && <p className={'shortDesc'}>{description}</p>}
              {isMatch && startTime && <p className={'time'}>{dateFormat(startTime * 1000, 'ddd, d mmm HH:MM')}</p>}
              {isMatch && league && (
                <p className={'league'}>
                  {leagueName} - {leagueType}
                </p>
              )}
            </>
          )}
          {/* {permission && permission !== 1 && (
            <p className={permission !== 1 ? 'free' : 'premium'}>
              {permission !== 1 ? 'Free Streaming' : 'Premium'}
            </p>
          )} */}
          {permission && permission === defaultPermissionCard && (
            <p className={permission !== 1 ? 'free' : 'premium'}>{permission !== 1 ? 'Free Streaming' : 'Premium'}</p>
          )}
        </div>
        {reminder && (
          <div style={{ marginTop: '.9rem' }}>
            <ReminderMatch id={id} reminder={reminder} />
          </div>
        )}
      </div>
    )
  }
}

export default VideoCard
